
import { Link } from 'react-router-dom';
import { useState } from 'react';
import AdminLoginModal from './AdminLoginModal';
import { useAuth } from '../../contexts/AuthContext';

export default function Footer() {
  const [showAdminLogin, setShowAdminLogin] = useState(false);
  const { isAdmin, signOut } = useAuth();

  const scrollToSection = (sectionId: string) => {
    if (window.location.pathname !== '/') {
      window.REACT_APP_NAVIGATE('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <>
      <footer className="bg-primary-dark text-white">
        <div className="max-w-[1400px] mx-auto px-5 py-8">
          {/* PC 레이아웃 - 버전 120 그대로 유지 */}
          <div className="hidden md:block">
            <div className="flex items-center gap-8 mb-5 flex-wrap">
              <div className="flex items-center gap-2 shrink-0">
                <div className="w-7 h-7 bg-white/10 rounded-md flex items-center justify-center">
                  <i className="ri-leaf-line text-white text-sm"></i>
                </div>
                <span className="text-sm font-bold text-white">KW테크</span>
              </div>

              <span className="text-white/30 text-sm">|</span>

              <span className="text-white/80 text-sm shrink-0">
                경기도 오산시 서동로 65번길 60
              </span>

              <span className="text-white/30 text-sm">|</span>

              <span className="text-sm font-bold text-white shrink-0">QUICK LINKS</span>

              <Link to="/about" className="text-white/80 text-sm hover:text-white transition-colors cursor-pointer shrink-0">
                회사소개
              </Link>
              <Link to="/products" className="text-white/80 text-sm hover:text-white transition-colors cursor-pointer shrink-0">
                제품소개
              </Link>
              <Link to="/inquiry" className="text-white/80 text-sm hover:text-white transition-colors cursor-pointer shrink-0">
                문의하기
              </Link>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-white/80 text-sm hover:text-white transition-colors text-left cursor-pointer shrink-0"
              >
                오시는길
              </button>
            </div>

            <div className="border-t border-white/20 pt-4 flex items-center justify-between">
              <p className="text-white/70 text-xs">&copy; 2025 KW테크. All rights reserved.</p>
              <div className="flex items-center gap-5">
                <a href="#" className="text-white/70 text-xs hover:text-white/80 transition-colors">
                  개인정보처리방침
                </a>
                <span className="text-white/30">|</span>
                <a href="#" className="text-white/70 text-xs hover:text-white/80 transition-colors">
                  이용약관
                </a>
                <span className="text-white/30">|</span>
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/70 text-xs hover:text-white/80 transition-colors">
                  Website Builder
                </a>
                <span className="text-white/30">|</span>
                {isAdmin ? (
                  <button
                    onClick={signOut}
                    className="text-white/70 text-xs hover:text-white/80 transition-colors cursor-pointer"
                  >
                    로그아웃
                  </button>
                ) : (
                  <button
                    onClick={() => setShowAdminLogin(true)}
                    className="text-white/20 text-xs hover:text-white/50 transition-colors cursor-pointer"
                  >
                    Admin
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* 모바일 레이아웃 */}
          <div className="block md:hidden">
            <div className="space-y-3 mb-6">
              <div className="flex items-center gap-2">
                <div className="w-7 h-7 bg-white/10 rounded-md flex items-center justify-center">
                  <i className="ri-leaf-line text-white text-sm"></i>
                </div>
                <span className="text-sm font-bold text-white">KW테크</span>
              </div>
              <div className="space-y-1.5 text-white/80 text-xs">
                <p>대표자: 오현근</p>
                <p>주소: 경기도 오산시 서동로 65번길 60</p>
                <p>이메일: mania2004@hanmail.net</p>
                <p>전화: 02-1234-5678</p>
              </div>
            </div>

            <div className="border-t border-white/20 pt-4">
              <p className="text-white/70 text-xs mb-3">&copy; 2025 KW테크. All rights reserved.</p>
              <div className="flex flex-col gap-2">
                <a href="#" className="text-white/70 text-xs hover:text-white/80 transition-colors">
                  개인정보처리방침
                </a>
                <a href="#" className="text-white/70 text-xs hover:text-white/80 transition-colors">
                  이용약관
                </a>
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/70 text-xs hover:text-white/80 transition-colors">
                  Website Builder
                </a>
                {isAdmin ? (
                  <button
                    onClick={signOut}
                    className="text-white/70 text-xs hover:text-white/80 transition-colors cursor-pointer text-left"
                  >
                    로그아웃
                  </button>
                ) : (
                  <button
                    onClick={() => setShowAdminLogin(true)}
                    className="text-white/20 text-xs hover:text-white/50 transition-colors cursor-pointer text-left"
                  >
                    Admin
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </footer>

      <AdminLoginModal isOpen={showAdminLogin} onClose={() => setShowAdminLogin(false)} />
    </>
  );
}
